"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _component = _interopRequireDefault(require("@loadable/component"));
var _TimeButton = _interopRequireDefault(require("./TimeButton.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ReactSVGIcon = (0, _component.default)(() => import("@micado-digital/react-svg-icon/ReactSVGIcon"));
const TimeButton = _ref => {
  let {
    currentTime,
    lang,
    setCurrentTime
  } = _ref;
  const {
    REACT_APP_PATH
  } = process.env;
  const css = (0, _TimeButton.default)();
  const timeInputRef = (0, _react.useRef)(null);
  const handleTimeChange = event => {
    const newTime = event.target.value;
    setCurrentTime(newTime);
  };
  const handleTimeClick = () => {
    if (timeInputRef.current) {
      timeInputRef.current.focus();
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.timeButton, "mco-bus-stops-intro__time"),
    onClick: handleTimeClick
  }, /*#__PURE__*/_react.default.createElement(ReactSVGIcon, {
    src: REACT_APP_PATH + "/img/icons/bus-stops/time.svg"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: css.timeButtonWrapper
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "time",
    ref: timeInputRef,
    value: currentTime,
    onChange: handleTimeChange
  }), lang === "de" && /*#__PURE__*/_react.default.createElement("label", null, "Uhr")));
};
var _default = exports.default = TimeButton;